module.exports = __webpack_public_path__ + "img/2f22133.webp";